import { Horizontal } from "Components/Horizontal";
import { RadioYesNo, RadioYesNoBool, VerticalRadio } from "Inputs/Radio";
import { Textbox } from "Inputs/Textbox";
import React from "react";

enum GaicTypeOfOperations {
  Corporation = "Corporation",
  Individual = "Individual / Sole Proprietor",
  Partnership = "Partnership / Joint Venture",
  LLC = "Limited Liability Company (LLC)",
  Other = "Other",
}

export interface TypeOfOperationInputProps {
  TypeOfOperationModel: {
    Type: string;
    HasDBAName?: string;
  };
}

export function TypeOfOperationInput(props: TypeOfOperationInputProps) {
  return (
    <>
      <Horizontal isRequired label="Type of Operation" shouldNotPadLabel>
        <VerticalRadio
          fieldName={"TypeOfOperationModel.Type"}
          options={[
            GaicTypeOfOperations.Corporation,
            GaicTypeOfOperations.Individual,
            GaicTypeOfOperations.Partnership,
            GaicTypeOfOperations.LLC,
            GaicTypeOfOperations.Other,
          ].map(option => [option, option])}
          value={props.TypeOfOperationModel.Type}
        />
        <input hidden name="TypeOfOperationModel.Type" />
      </Horizontal>
      {props.TypeOfOperationModel.Type === GaicTypeOfOperations.Individual && (
        <>
          <Horizontal>
            <RadioYesNoBool fieldName="TypeOfOperationModel.HasDBAName">
              <div>Are you operating under a Doing Business As (DBA) name?</div>
            </RadioYesNoBool>
          </Horizontal>
          {props.TypeOfOperationModel.HasDBAName === "true" && (
            <Horizontal isRequired label="DBA Name">
              <Textbox
                fieldName="TypeOfOperationModel.DBAName"
                placeholder="DBA Name"
              />
            </Horizontal>
          )}
        </>
      )}
      {props.TypeOfOperationModel.Type === GaicTypeOfOperations.Other && (
        <Horizontal isRequired label="Other Type">
          <Textbox
            fieldName="TypeOfOperationModel.OtherType"
            placeholder="Other Type"
          />
        </Horizontal>
      )}
    </>
  );
}
